"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (props) {
    var classes = [];
    classes.push(props.horizontalAlignment);
    classes.push(props.verticalAlignment);
    classes.push(props.color);
    classes.push(props.className);
    classes.push(props.border);
    classes.push(props.borderColor);
    classes.push(props.borderStyle);
    classes.push(props.noBorder);
    classes.push(props.fontSize);
    classes.push(props.fontSizeImportant);
    classes.push(props.fontSizeSSMediumUp);
    classes.push(props.height);
    classes.push(props.size);
    classes.push(props.width);
    return classes.filter(function (c) { return c != undefined; });
});
//# sourceMappingURL=distillUtilityClasses.js.map